import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

export interface ForceLoginDialogData {
  onForceLogin: () => void;
  onCancel: () => void;
}

@Component({
  selector: 'app-force-login-popup',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatProgressSpinner],
  templateUrl: './force-login-popup.component.html',
  styleUrls: ['./force-login-popup.component.css'],
})
export class ForceLoginPopupComponent {
  constructor(
    public dialogRef: MatDialogRef<ForceLoginPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ForceLoginDialogData
  ) {}
  loading: boolean = false;

  forceLogin(): void {
    this.data.onForceLogin();
    this.loading = true;

  }

  cancel(): void {
    this.data.onCancel();
    this.dialogRef.close();
  }
}
